import { useState } from "react";
import { Button, Col, Row } from "reactstrap";
import { MiniContact } from "../ContactUs/MiniContact";



export const Banner = () => {
    const [showDialog, setShowDialog] = useState(false);

    const showHideDialog = () => {
        if (showDialog) {
            setShowDialog(false);
        }
        else {
            setShowDialog(true);
            window.scrollTo(0, 0);
        }
    };

    return (
        <div className={`bannerContainer fixed ${showDialog ? 'active' : ''}`}>
            <Row>
                <Col className={`bannerTitle ${showDialog ? 'active' : ''}`}>
                    <Button className={`buttonAsLink ${showDialog ? 'active white' : 'white'} openCloseChevron`} onClick={showHideDialog}>
                        <strong>Send us your information and we'll get in touch.</strong>Ready to discuss your fleet with our experts?&nbsp;&nbsp;
                    </Button>
                </Col>
            </Row>
            {showDialog ? (
                <Row>
                    <Col>
                        <MiniContact closeHandler={showHideDialog} />
                    </Col>
                </Row>
            ) : ('')}
        </div>
    );
}